import HourlyFourth from "./HourlyFourth";

export default HourlyFourth;